import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Home, ArrowLeft } from 'lucide-react'

export function NotFound() {
  const { t } = useTranslation('profile')
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary-600">404</h1>
          <h2 className="text-2xl font-semibold text-gray-900 mt-4">
            {t('pageNotFound')}
          </h2>
          <p className="text-gray-600 mt-2">
            {t('pageNotFoundMessage')}
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="btn btn-primary px-6 py-3 inline-flex items-center"
          >
            <Home className="h-4 w-4 mr-2" />
            {t('goHome')}
          </Link>
          
          <div>
            <button
              onClick={() => window.history.back()}
              className="btn btn-outline px-6 py-3 inline-flex items-center"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t('goBack')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
